import PropTypes from 'prop-types';
import React, {Component} from 'react';

const propTypes = {
  onClose: PropTypes.func.isRequired,
  children: PropTypes.any,
};

export default class FullWidthModal extends Component {
  componentDidMount() {
    document.addEventListener('keypress', e => {
      if (e.which === 27) { // ESC
        this.props.onClose();
      }
    });
  }

  render() {
    return <div className='modal-backdrop'>
      <div className='full-width-modal'>
        <div className='container'>
          {this.props.children}
        </div>
      </div>
    </div>;
  }
}
FullWidthModal.propTypes = propTypes;
